import _ from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import {
  useDeleteWorkoutCommentMutation,
  useGetWorkoutCommentsQuery,
  useGetWorkoutDetailsQuery,
} from "../../Data/services/workoutApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import ExerciseCard from "../../Pages/WorkoutManagement/component/ExerciseCard";
import Comment from "../Comment/comment";
import {
  Description,
  EmptyContainer,
  Loader,
  SubTitle,
} from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import CommentShimmer from "../Shimmers/comment_shimmer";
import UserAvatarWithNameAndTag from "../UserAvatar/UserAvatarWithNameAndTag";
import cssStyles from "./styles/viewModal.module.scss";

const ViewWorkoutModal = ({ handleModalClose, data, modalTitle }) => {
  const workoutId = data.slug;
  const [comments, setComments] = useState([]);

  const {
    data: commentData,
    isSuccess,
    isLoading,
    isFetching,
    refetch,
  } = useGetWorkoutCommentsQuery(workoutId);

  const {
    data: workoutData,
    isSuccess: getSuccess,
    isLoading: getLoading,
    isFetching: getFetching,
    refetch: getRefresh,
  } = useGetWorkoutDetailsQuery(workoutId);

  // console.log(workoutId);
  // console.log(commentData);
  console.log(workoutData);

  useEffect(() => {
    if (commentData) {
      console.log(commentData.data);
      setComments(commentData.data);
    }
  }, [commentData]);

  const [deleteComment] = useDeleteWorkoutCommentMutation();

  const handleCommentDelete = async (slug) => {
    console.log(slug);

    try {
      const { data } = await deleteComment(slug);

      console.log(data);

      if (data.code === 200) {
        await refetch();
        SuccessToast(data.message);
      }
    } catch (error) {
      console.log(error);
      Toast(error.message, "error");
    }
  };

  return (
    <div>
      <ModalContainer handleClose={handleModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0"> {modalTitle} </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>

          <Row className="w-100 h-100">
            <Col md={6} sm={12} className="">
              <div className="d-flex align-items-start w-100 h-100">
                {data.image_url ? (
                  <img
                    src={data.image_url}
                    alt=""
                    width="100%"
                    className={`${cssStyles.workoutImage}`}
                  />
                ) : null}
              </div>
            </Col>
            <Col md={6} sm={12} className="">
              <div className="d-flex flex-column justify-content-start align-items-top w-100 h-100">
                <SubTitle classes="lc-1" text={data.title} />

                {/* <Description
                  classes="my-1 gray-text"
                  text={`Published date: ${moment(data.createdAt).format(
                    "MMMM Do YYYY"
                  )}`}
                /> */}

                <div className="d-flex flex-row justify-content-between align-items-center">
                  <UserAvatarWithNameAndTag
                    avatarImage={data.user_image}
                    userName={data.user_name}
                    // userTag={"@username"}
                  />

                  <SubTitle
                    text={data.price === null ? "Free" : "$ " + data.price}
                  />
                </div>

                <Description classes="my-2" text={data.description} />

                <Description classes="my-2 gray-text" text={"Tags:"} />

                <div className="w-100 d-flex flex-row flex-wrap justify-content-left">
                  {(data.tags ?? []).map((item, index) => {
                    return (
                      <p
                        className="fw-bold text-white py-2 px-4 bg-carrotOrange rounded-3"
                        key={index}
                      >
                        {item}
                      </p>
                    );
                  })}
                </div>

                <p className="m-0 mt-4 text-white fs-4">Exercises</p>

                {_.isEmpty(workoutData?.data?.exercise) ? (
                  isFetching ? (
                    <Loader />
                  ) : (
                    <EmptyContainer text="No exercises in this workout." />
                  )
                ) : (
                  <Row className={` mt-2 mb-2`} gutter={[0, 24]}>
                    {(workoutData?.data?.exercise ?? []).map(
                      (exercise, index) => {
                        return (
                          <Col sm={12} md={12} key={index}>
                            <ExerciseCard
                              exerciseNumber={"Exercise " + (index + 1)}
                              heading={exercise.title}
                              text={exercise.details}
                            />
                          </Col>
                        );
                      }
                    )}
                  </Row>
                )}

                <hr></hr>

                <SubTitle classes="lc-1 fs-5 mb-4" text="Comments" />

                {/* Shimmer */}
                {isLoading ? <CommentShimmer /> : ""}

                {isSuccess
                  ? comments.length > 0
                    ? comments.map((comment, i) => {
                        // console.log(comment);
                        // console.log(i);
                        return (
                          <>
                            <Comment
                              userName={comment.name}
                              // tag="@abcdefghijk"
                              avatarImage={comment.image_url}
                              commentTime={moment(comment.createdAt).fromNow()}
                              commentText={comment.comment}
                              commentSlug={comment.slug}
                              onCommentDelete={handleCommentDelete}
                            />
                            {i <= 3 ? <hr></hr> : ""}
                          </>
                        );
                      })
                    : "No Comment Found."
                  : ""}
              </div>
            </Col>
          </Row>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ViewWorkoutModal;
